import axios from "axios";
import Cookies from "js-cookie";
const token = Cookies.get("googleToken");

const googleServices = {
  actions: {
    async retrieveFilesInFolder(_, folderId) {
      if (!token) {
        throw new Error("No se encontró el token en la cookie googleToken.");
      }

      const response = await axios.get(
        "https://www.googleapis.com/drive/v3/files",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          params: {
            orderBy: "folder",
            pageSize: 200,
            q: `parents in "${folderId}" and trashed = false`,
          },
        }
      );

      return response;
    },
  },
};


export default googleServices